import type { ColumnDef } from "@tanstack/react-table";

import { DataTableColumnHeader } from "@/components/DataTable/Columns/DataTableColumnHeader";
import type { HelperOptions } from "@/components/DataTable/types";
import { AvatarAppIntegrationLink } from "@/features/app/components/Avatar/AvatarAppIntegrationLink";
import { AppIntegrationPreviewContent } from "@/features/app/components/PreviewCard/AppIntegrationPreviewContent";

type Row = {
  appIntegration: {
    appId: string;
    appIntegrationId: string;
    appName: string;
    tenantName?: string;
    avatarUrl?: string;
  };
};

export default function IntegratedAppColumn<TData extends Row>(
  id: keyof TData,
  helperOptions: HelperOptions,
): ColumnDef<TData> {
  const { minWidth } = helperOptions;
  return {
    accessorKey: id,
    meta: { thStyle: { minWidth }, i18nKey: "software" },
    enableSorting: true,
    header: DataTableColumnHeader,
    cell: ({ row }) => {
      const { appIntegration } = row.original;
      return (
        <AvatarAppIntegrationLink
          appIntegrationId={appIntegration.appIntegrationId}
          avatarUrl={appIntegration.avatarUrl}
          name={appIntegration.appName}
          size="Large"
          showLabel={false}
          previewCardContent={
            <AppIntegrationPreviewContent
              appIntegration={{
                id: appIntegration.appIntegrationId,
                ...appIntegration,
              }}
            />
          }
          previewCardClassName="w-auto"
        />
      );
    },
  } satisfies ColumnDef<TData>;
}
